import { OrderReviewType } from "@core/types";

export const getDeliveryQualityFromReview = (review: OrderReviewType): number => {
  if (review.deliveryQuality != null) {
    return review.deliveryQuality;
  }
  const legacyScores = [review.deliverySpeed, review.driverCourtesy, review.assemblyQuality].filter(
    (v): v is number => v != null,
  );
  if (legacyScores.length === 0) {
    return 0;
  }
  return Math.round(legacyScores.reduce((sum, v) => sum + v, 0) / legacyScores.length);
};

export const getOrderReviewOverallRating = (review: OrderReviewType): number => {
  const product = review.productQuality;
  const delivery = getDeliveryQualityFromReview(review);
  if (review.appUsability != null) {
    return Math.round(((product + delivery + review.appUsability) / 3) * 10) / 10;
  }
  return product;
};
